const app = require('./app')
app.mount('main')
